module.exports = __webpack_public_path__ + "img/entelli_logo.6cbe595d.png";